// extracted by mini-css-extract-plugin
export var confirmationRow = "confirmation-row_Utx_YENtNqS8ZDaDXdDt";
export var domainChip = "domain-chip_sr1KY1rbOAmPSmMmXJeq";
export var domainChipList = "domain-chip-list_rDxLPj3rdOWxHRUif8jq";
export var domainsCard = "domains-card_Yfuh1BfPtuN3cLARa89q";
export var domainsCardFooter = "domains-card-footer_XrLFJwhDCJ02ATRZrg3k";
export var domainsCardHeader = "domains-card-header_gGPvkz7EDS47SZWibmcA";
export var infoBanner = "info-banner_qRpM5A4rHm7vozp3TDTV";
export var infoBannerSubtitle = "info-banner-subtitle_MNUB8EQMyMmVTlBK3_11";
export var infoBannerTitle = "info-banner-title_m3bsiRvqTPlge3ULOaQ8";
export var instructionsCard = "instructions-card_mxmLjqHMADAH4MW_xjom";
export var instructionsList = "instructions-list_qsms43Ntr0IbPhK93gYV";
export var providerNote = "provider-note_kcaHiC2FU_k_R7Owprz3";
export var testEndUserContainer = "test-end-user-container_TjWNwQpDK1gT0rEPRooh";